import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';

// TODO esto debe eliminarse tras migrar todos los grupos de mars a su propia colección
export const MarsGroupResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  router: Router = inject(Router)
): boolean => {
  const group = route.parent.data.group;
  if (!group) return null;

  if (group.gameCanonicName === 'mars') {
    router.navigate(['/groups/mars', route.params.groupId]).then();
    return true;
  }
  return false;
};
